import { REQUEST_COUPONS, RECEIVE_COUPONS, FAILURE_COUPONS } from './constants';
import { combineReducers } from 'redux';

/*
 * State shape
 {
    coupons: {
        [idPartner]: [coupon list],
        [idPartner]: [coupon list]
    },
    fetching: false,
    error: ''
 }
 */

const coupons = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_COUPONS:
            return { ...state, [action.idPartner]: action.response.payload };
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_COUPONS:
            return true;
        case FAILURE_COUPONS:
        case RECEIVE_COUPONS:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_COUPONS:
            return action.response.message;
        case REQUEST_COUPONS:
        case RECEIVE_COUPONS:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    coupons,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/coupon/reducer.js